import React from 'react';
import EducatorDashboard from './EducatorDashboard';

function EducatorHomeScreen() {

  return (
    <div>
      <h2>Welcome, Educator!</h2>
      <EducatorDashboard />
    </div>
  );
}

export default EducatorHomeScreen;
